<template>
  <div class="component-upload-image">
    <el-upload ref="imageUpload" multiple :action="uploadImgUrl" list-type="picture-card"
      :on-success="handleUploadSuccess" :before-upload="handleBeforeUpload" :limit="limit" :on-error="handleUploadError"
      :on-exceed="handleExceed" :on-remove="handleDelete" :show-file-list="true" :headers="headers" :file-list="fileList"
      :on-preview="handlePictureCardPreview" :class="{ hide: fileList.length >= limit }">
      <i class="el-icon-plus"></i>
      <!-- 上传提示 -->
      <!-- <template #tip>
        <div v-if="showTip" class="el-upload__tip">
          请上传
          <template v-if="fileSize">{{ $t('message.home.大小不超过') }}<b style="color: #f56c6c">{{ fileSize }}MB</b></template>
          <template v-if="fileType">{{ $t('message.home.格式为') }}<b style="color: #f56c6c">{{ fileType.join("/") }}</b></template>
          的文件
        </div>
      </template> -->
    </el-upload>

    <el-dialog v-model="dialogVisible" :title="$t('message.home.预览')" width="800" append-to-body>
      <img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />
    </el-dialog>
  </div>
</template>

<script>
// import store from '@/store/index'
export default {
  props: {
    modelValue: { type: [String, Object, Array], default: null },
    // 图片数量限制
    limit: {
      type: Number,
      default: 1
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 5
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ['png', 'jpg', 'jpeg']
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      hideUpload: false,
      headers: {
        // Authorization: 'Bearer ' + store.getters.access_token,
      },
      uploadImgUrl: '/upms/file/upload?fileType=image&path=admin', // 上传的图片服务器地址
      fileList: []
    }
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize)
    }
    // ,
    // headers: function () {
    //   return {
    //     Authorization: 'Bearer ' + store.getters.access_token
    //   }
    // }
  },
  watch: {
    modelValue: {
      handler(val) {
        if (val) {
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.modelValue.split(',')
          // 然后将数组转为对象数组
          this.fileList = list.map(item => {
            if (typeof item === 'string') {
              if (item.indexOf(this.baseUrl) === -1) {
                item = { name: this.baseUrl + item, url: this.baseUrl + item }
              } else {
                item = { name: item, url: item }
              }
            }
            return item
          })
        } else {
          this.fileList = []
          return []
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 上传前loading加载
    handleBeforeUpload(file) {
      let isImg = false
      if (this.fileType.length) {
        let fileExtension = ''
        if (file.name.lastIndexOf('.') > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1)
        }
        isImg = this.fileType.some(type => {
          if (file.type.indexOf(type) > -1) return true
          if (fileExtension && fileExtension.indexOf(type) > -1) return true
          return false
        })
      } else {
        isImg = file.type.indexOf('image') > -1
      }
      if (!isImg) {
        this.$message.error(`文件格式不正确, 请上传${this.fileType.join('/')}图片格式文件!`)
        return false
      }
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize
        if (!isLt) {
          this.$message.error(`上传头像图片大小不能超过 ${this.fileSize} MB!`)
          return false
        }
      }
      this.number++
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`)
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      this.$emit('update:modelValue',this.baseUrl + res.link);
      // this.uploadList.push({ name: res.data.fileName, url: this.baseUrl + res.link });
      // this.uploadedSuccessfully();
      // if (res.code === 0) {
      //   this.uploadList.push({ name: res.data.fileName, url: this.baseUrl + res.link })
      //   this.uploadedSuccessfully()
      // } else {
      //   this.number--
      //   this.$message.error(res.msg)
      //   this.$refs.imageUpload.handleRemove(file)
      //   this.uploadedSuccessfully()
      // }
    },
    // 删除图片
    handleDelete(file) {
      const findex = this.fileList.map(f => f.name).indexOf(file.name)
      if (findex > -1) {
        this.fileList.splice(findex, 1)
        // this.$emit('update:modelValue', this.listToString(this.fileList))
        this.$emit('handleImagesUrl',"");
      }
    },
    // 上传失败
    handleUploadError() {
      this.$message.error('上传图片失败，请重试')
    },
    // 上传结束处理
    uploadedSuccessfully() {
      if (this.number > 0 && this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList)
        this.uploadList = []
        this.number = 0
        this.$emit('handleImagesUrl', res.link);
        // this.$emit('update:modelValue', this.listToString(this.fileList))
      }
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = ''
      separator = separator || ','
      for (const i in list) {
        if (list[i].url) {
          strs += list[i].url.replace(this.baseUrl, '') + separator
        }
      }
      return strs !== '' ? strs.substr(0, strs.length - 1) : ''
    }
  }
}
</script>
<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
:deep(.hide .el-upload--picture-card) {
  display: none;
}

// 去掉动画效果
:deep(.el-list-enter-active),
:deep(.el-list-leave-active) {
  transition: all 0s;
}

:deep(.el-list-enter, .el-list-leave-active) {
  opacity: 0;
  transform: translateY(0);
}
</style>

